<template>
    <aside>
        <div class="section-data" style="min-height: 400px;">
            <div class="title d-flex justify-content-between">
                <div class="text">
                    <div id="slot-title">
                    </div>
                    <h3 class="font-blue">Eliminar Vacante</h3>
                    <p class="font-gray-dark">Opciones de eliminación</p>
                </div>
                <div class="tools">
                    <div id="slot-tools">
                    </div>
                </div>
            </div>
            <div class="data">
                <div class="container my-3">
                    <div id="slot-content">
                    </div>
                    <div class="content">

                        <div class="target-downloading text-center p-1 font-gray-dark" v-if="downloading">
                            <b-spinner small label="Espere ..."></b-spinner>
                            <span class="p-1">Espere un momento...</span>
                        </div>

                        <div class="target-body" v-show="!downloading">
                            <div class="row">
                                <div class="col-lg-12">
                                    <p>
                                        Vemos que estás a punto de eliminar una vacante.<br>
                                        Por favor, compártenos cual es el motivo
                                    </p>
                                    <b-form @submit="removeJob">
                                        <b-form-group label="Selecciona una opción">
                                            <b-form-radio v-model="option_selected" name="some-radios"
                                                          value="Encontré el candidato en Kllaar">Encontré el candidato
                                                en Kllaar
                                            </b-form-radio>
                                            <b-form-radio v-model="option_selected" name="some-radios"
                                                          value="No encontré candidatos adecuados para la vacante">No
                                                encontré candidatos adecuados para la vacante
                                            </b-form-radio>
                                            <b-form-radio v-model="option_selected" name="some-radios"
                                                          value="Encontré el candidato en otra plataforma">Encontré el
                                                candidato en otra plataforma
                                            </b-form-radio>
                                            <b-form-radio v-model="option_selected" name="some-radios" value="other">
                                                Otro motivo
                                            </b-form-radio>
                                        </b-form-group>
                                        <b-form-group label="Otro motivo" v-if="option_selected == 'other'">
                                            <b-form-input v-model="form.selected" type="text" autofocus required
                                                          placeholder="Ingresa otro motivo"></b-form-input>
                                        </b-form-group>

                                        <button type="button" class="btn text-danger" @click="remove = true"
                                                v-show="!remove && option_selected">Eliminar Vacante
                                        </button>
                                        <div class="__remove" v-if="remove">
                                            <button type="button" class="btn font-gray-dark" @click="remove = false">
                                                Cancelar
                                            </button>
                                            <b-button type="submit" class="b-red" :disabled="loading.delete"
                                                      v-if="remove">
                                                <b-spinner v-if="loading.delete" small label="Espere ..."></b-spinner>
                                                <i class="fas fa-trash" v-if="!loading.delete"></i> Eliminar Empleo
                                            </b-button>
                                        </div>
                                    </b-form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </aside>
    <!--    <div class="target b-white rounded shadow-sm">-->
    <!--        <div class="target-title border-bottom">-->
    <!--            <h4 class="font-blue"></h4>-->
    <!--            <span class="font-gray-dark"></span>-->
    <!--        </div>-->

    <!--    </div>-->
</template>
<style scoped>

</style>
<script>
export default {
    data() {
        return {
            downloading: false,
            option_selected: '',
            form: {
                selected: '',
            },
            remove: false,
            loading: {
                delete: false
            }
        }
    },
    watch: {
        option_selected: function (val) {
            if (val == 'other') {
                this.form.selected = ''
            } else {
                this.form.selected = val
            }
        }
    },
    methods: {
        removeJob(e) {
            e.preventDefault()

            let id = this.$route.params.id
            this.loading.delete = true
            this.api.post('enterprise/job/delete/' + id, JSON.stringify(this.form)).then(({data}) => {
                this.loading.delete = false
                this.$router.push('/perfil/empleos')
            }).catch(err => {
                this.loading.delete = false
                console.log(err)
            });
        },
    },
    created() {

    }

}
</script>



// WEBPACK FOOTER //
// src/components/#pages/jobs/pages/DeleteJob.vue